// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { 
//   getPackages, 
//   approvePackage, 
//   rejectPackage, 
//   deletePackage,
//   getPackageHistory
// } from '../services/api';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import logo from '../assets/ZAUNTRIP-Logo1.png';

// const ViewPackages = () => {
//   const [packages, setPackages] = useState([]);
//   const [filteredPackages, setFilteredPackages] = useState([]);
//   const [selectedPackage, setSelectedPackage] = useState(null);
//   const [approvalHistory, setApprovalHistory] = useState([]);
//   const [linkedPrevious, setLinkedPrevious] = useState([]);
//   const [rates, setRates] = useState({});
//   const [loading, setLoading] = useState(true);
//   const role = localStorage.getItem('role') || 'employee';
//   const userId = parseInt(localStorage.getItem('user_id') || '0', 10);
//   const navigate = useNavigate();
//   const location = useLocation();
  
//   const filterStatus = location.state?.filterStatus;

//   const approvalOrder = ['manager', 'functional_admin', 'super_admin'];
//   const symbols = { USD: '$', INR: '₹' };
//   const costingFields = [
//     'Flights / Airfare', 'Accommodation', 'Transfers', 'Sightseeing', 'Meals',
//     'Visa Fees', 'Travel Insurance', 'Guide / Driver Tips',
//   ];
//   const convertedFields = [
//     'Mark-up', 'Per Pax Selling Price', 'Less: Agent Commission',
//     'Less: Transaction Charges', 'Gross Margin'
//   ];

//   const fetchRates = async () => {
//     try {
//       const res = await fetch('https://open.er-api.com/v6/latest/USD');
//       const data = await res.json();
//       if (data.result === 'success') setRates(data.rates);
//     } catch (err) {
//       console.error('Failed to fetch exchange rates:', err);
//     }
//   };

// const fetchPackages = async () => {
//   setLoading(true);
//   try {
//     const response = await getPackages();
//     const data = Array.isArray(response.data) ? response.data : [];
    
//     console.log('DEBUG: All packages from API:', data);
    
//     const parsedPackages = data.map(pkg => {
//       let parsedData = {};
//       try {
//         parsedData = typeof pkg.data === 'string' ? JSON.parse(pkg.data) : pkg.data || {};
//       } catch (e) {
//         parsedData = {};
//       }
//       return {
//         ...pkg,
//         currency: pkg.currency || 'INR',
//         converted_currency: pkg.converted_currency || null,
//         data: parsedData,
//         approver_role: pkg.approver_role || null,
//         assigned_approver_id: parseInt(pkg.assigned_approver_id) || null,
//         user_id: parseInt(pkg.user_id) || 0
//       };
//     });
    
//     setPackages(parsedPackages);
    
//     let filtered = parsedPackages;

//     if (role === 'super_admin') {
//       filtered = parsedPackages;
//     } else if (role === 'employee') {
//       filtered = parsedPackages.filter(pkg => pkg.user_id === userId);
//     } else if (role === 'manager') {
//       filtered = parsedPackages.filter(pkg => {
//         if (pkg.user_id === userId) return true;
//         const isPendingForManager = pkg.status === 'pending' && pkg.approver_role === 'manager';
//         const isMyAssignment = !pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === userId;
//         if (isPendingForManager && isMyAssignment) return true;
//         if (pkg.status === 'approved_by_manager' || pkg.status === 'rejected_by_manager') return true;
//         if (pkg.status === 'approved_by_functional_admin' || pkg.status === 'fully_approved') return true;
//         return false;
//       });
//     } else if (role === 'functional_admin') {
//       // FIX: expanded filter so FA sees all relevant packages
//       filtered = parsedPackages.filter(pkg => {
//         // Pending packages directly assigned to FA
//         if (pkg.status === 'pending' && pkg.approver_role === 'functional_admin') return true;
//         // Packages approved by manager — now awaiting FA action
//         if (pkg.status === 'approved_by_manager') return true;
//         // Packages FA has already acted on
//         if (pkg.status === 'approved_by_functional_admin') return true;
//         if (pkg.status === 'fully_approved') return true;
//         if (pkg.status.startsWith('rejected_by_functional_admin')) return true;
//         if (pkg.status.startsWith('rejected_by_manager')) return true;
//         return false;
//       });
//     }
    
//     // Apply status filter if provided
//     if (filterStatus && filterStatus !== 'all') {
//       if (filterStatus === 'pending') {
//         const actionableForRole = {
//           manager:          ['pending'],
//           functional_admin: ['pending', 'approved_by_manager'],
//           super_admin:      ['pending', 'approved_by_manager', 'approved_by_functional_admin']
//         };
//         const pendingStatuses = actionableForRole[role] || ['pending'];
//         // FIX: removed "&& pkg.approver_role === role" which was blocking approved_by_manager packages for FA
//         filtered = filtered.filter(pkg => pendingStatuses.includes(pkg.status));
//       } else if (filterStatus === 'approved') {
//         filtered = filtered.filter(pkg =>
//           pkg.status === 'fully_approved' ||
//           pkg.status.startsWith('approved_by_')
//         );
//       } else if (filterStatus === 'rejected') {
//         filtered = filtered.filter(pkg => pkg.status.startsWith('rejected_by_'));
//       }
//     }
    
//     console.log(`DEBUG: Filtered packages for ${role} (ID: ${userId}):`, filtered);
//     setFilteredPackages(filtered);
    
//   } catch (error) {
//     console.error('Failed to fetch packages:', error.message);
//     setPackages([]);
//     setFilteredPackages([]);
//   } finally {
//     setLoading(false);
//   }
// };

//   const formatDate = (dateString) => {
//     if (!dateString || isNaN(new Date(dateString).getTime())) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-GB', {
//       day: '2-digit', month: '2-digit', year: 'numeric'
//     });
//   };

//   const formatDateTime = (dateString) => {
//     if (!dateString || isNaN(new Date(dateString).getTime())) return 'N/A';
//     return new Date(dateString).toLocaleString('en-GB', {
//       day: '2-digit', month: '2-digit', year: 'numeric',
//       hour: '2-digit', minute: '2-digit', hour12: true
//     });
//   };

// const canAct = (pkg) => {
//   if (!pkg.approver_role) return false;

//   const actionableStatuses = {
//     manager:          ['pending'],
//     functional_admin: ['pending', 'approved_by_manager'],
//     super_admin:      ['pending', 'approved_by_manager', 'approved_by_functional_admin']
//   };
//   const allowed = actionableStatuses[role] || ['pending'];
//   if (!allowed.includes(pkg.status)) return false;

//   if (pkg.approver_role !== role) return false;

//   if (pkg.assigned_approver_id) {
//     return Number(pkg.assigned_approver_id) === Number(userId);
//   }

//   return true;
// };

//   const handleApprove = async (referenceId) => {
//     const pkgRole = selectedPackage?.approver_role || role;
//     try {
//       await approvePackage(referenceId, pkgRole);
//       alert('Package approved successfully!');
//       closeModal();
//       await fetchPackages();
//     } catch (error) {
//       console.error('Approve error:', error);
//       alert('Failed to approve package. Please try again. Error: ' + (error.response?.data?.error || error.message));
//     }
//   };

//   const handleReject = async (referenceId) => {
//     if (window.confirm('Are you sure you want to reject this package?')) {
//       const pkgRole = selectedPackage?.approver_role || role;
//       try {
//         await rejectPackage(referenceId, pkgRole);
//         alert('Package rejected successfully!');
//         closeModal();
//         await fetchPackages();
//       } catch (error) {
//         console.error('Reject error:', error);
//         alert('Failed to reject package. Please try again. Error: ' + (error.response?.data?.error || error.message));
//       }
//     }
//   };

//   const handleDelete = async (referenceId) => {
//     if (window.confirm('Are you sure you want to delete this package?')) {
//       try {
//         await deletePackage(referenceId);
//         alert('Package deleted successfully!');
//         await fetchPackages();
//         if (selectedPackage?.reference_id === referenceId) setSelectedPackage(null);
//       } catch (error) {
//         console.error('Delete error:', error);
//         alert('Failed to delete package. Please try again.');
//       }
//     }
//   };

//   const handleView = async (pkg) => {
//     let safePkg = { ...pkg };
//     try {
//       safePkg.data = typeof pkg.data === 'string' ? JSON.parse(pkg.data) : pkg.data || {};
//     } catch (e) {
//       safePkg.data = {};
//     }

//     setSelectedPackage(safePkg);
//     setLinkedPrevious(pkg.linked_previous || []);

//     try {
//       const res = await getPackageHistory(pkg.reference_id);
//       const history = Array.isArray(res.data?.history) ? res.data.history : [];

//       const formattedHistory = history.map(h => ({
//         type:       h.type || 'approval',
//         action:     h.action || (h.approved ? 'APPROVED' : 'REJECTED'),
//         role:       h.role || 'employee',
//         user_name:  h.approver_name  || 'N/A',
//         user_email: h.approver_email || 'N/A',
//         created_at: h.approved_at
//       }));

//       setApprovalHistory(formattedHistory);
//     } catch (err) {
//       console.error('Failed to fetch approval history:', err);
//       setApprovalHistory([{
//         type:       'created',
//         action:     'CREATED',
//         role:       'employee',
//         user_name:  safePkg.data['Employee Name'] || 'N/A',
//         user_email: safePkg.data['Agent Email']   || 'N/A',
//         created_at: pkg.created_at
//       }]);
//     }
//   };

//   const handleEdit = (pkg) => {
//     if (role === 'employee' && pkg.user_id === userId && pkg.status === 'pending') {
//       navigate(`/dashboard/edit-package/${pkg.reference_id}`, { state: { package: pkg } });
//     } else {
//       alert('You can only edit your own pending packages.');
//     }
//   };

//   const closeModal = () => {
//     setSelectedPackage(null);
//     setApprovalHistory([]);
//     setLinkedPrevious([]);
//   };

//   const numberToWords = (num) => {
//     if (isNaN(num) || num === 0) return 'Zero';
//     const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
//     const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
//     const scales = ['', 'Thousand', 'Million', 'Billion'];

//     const convertChunk = (n) => {
//       if (n === 0) return '';
//       if (n < 10) return units[n];
//       if (n < 20) return teens[n - 10];
//       if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + units[n % 10] : '');
//       return units[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + convertChunk(n % 100) : '');
//     };

//     const chunks = [];
//     let remaining = Math.floor(Math.abs(num));
//     for (let i = 0; remaining > 0 && i < scales.length; i++) {
//       const chunk = remaining % 1000;
//       if (chunk > 0) chunks.unshift(convertChunk(chunk) + (chunk > 99 ? ' ' : '') + scales[i]);
//       remaining = Math.floor(remaining / 1000);
//     }
//     return chunks.join(' ').trim() + (num < 0 ? ' Negative' : '') + ' Only';
//   };

//   const getLogoBase64 = async () => {
//     return new Promise((resolve) => {
//       const img = new Image();
//       img.src = logo;
//       img.onload = () => {
//         const canvas = document.createElement('canvas');
//         canvas.width = img.naturalWidth;
//         canvas.height = img.naturalHeight;
//         const ctx = canvas.getContext('2d');
//         ctx.drawImage(img, 0, 0);
//         resolve(canvas.toDataURL('image/png'));
//       };
//       img.onerror = () => resolve(null);
//     });
//   };

//   const handleDownloadPDF = async (pkg) => {
//     if (!pkg || !pkg.reference_id) return alert('Invalid package');

//     let data = {};
//     try {
//       data = typeof pkg.data === 'string' ? JSON.parse(pkg.data) : pkg.data || {};
//     } catch (e) {
//       return alert('Package data corrupted');
//     }

//     const doc = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = doc.internal.pageSize.getWidth();
//     let y = 20;

//     const logoBase64 = await getLogoBase64();
//     if (logoBase64) doc.addImage(logoBase64, 'PNG', 10, 6, 30, 10);

//     doc.setFontSize(16);
//     doc.text('Package Costing', pageWidth / 2, 15, { align: 'center' });

//     doc.setFontSize(10);
//     doc.text(`Reference ID: ${pkg.reference_id}`, 10, y); y += 8;
//     doc.text(`Created: ${formatDate(pkg.created_at)}`, 10, y); y += 8;
//     doc.text(`Status: ${pkg.status.replace(/_/g, ' ').toUpperCase()}`, 10, y); y += 12;

//     const rows = Object.entries(data).map(([k, v]) => [k, v || '-']);
//     autoTable(doc, { startY: y, head: [['Cost Head', 'Amount']], body: rows, theme: 'grid', styles: { fontSize: 9 } });

//     let nextY = doc.lastAutoTable.finalY + 10;
//     doc.setFontSize(12);
//     doc.text('Approval History', 10, nextY); nextY += 8;

//     if (approvalHistory.length > 0) {
//       autoTable(doc, {
//         startY: nextY,
//         head: [['Action', 'Role', 'User', 'Date & Time']],
//         body: approvalHistory.map(h => [
//           h.action,
//           h.role,
//           `${h.user_name} (${h.user_email})`,
//           formatDateTime(h.created_at)
//         ]),
//         styles: { fontSize: 9 }
//       });
//     }

//     doc.save(`Package_Costing_${pkg.reference_id}.pdf`);
//   };

// useEffect(() => {
//   fetchPackages();
//   fetchRates();

//   const interval = setInterval(() => {
//     fetchPackages();
//   }, 5000); // 🔥 5 sec ma auto refresh

//   return () => clearInterval(interval);
// }, [filterStatus]);

//   return (
//     <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
//       <div className="flex flex-wrap justify-between items-center mb-4 sm:mb-6 gap-2">
//         <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">View Packages</h2>
//         {filterStatus && (
//           <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm font-medium">
//             Filter: {filterStatus}
//           </span>
//         )}
//       </div>

//       {loading ? (
//         <div className="flex justify-center items-center h-64">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//           <span className="ml-4 text-gray-600">Loading packages...</span>
//         </div>
//       ) : filteredPackages.length > 0 ? (
//         <>
//           {/* Mobile Cards */}
//           <div className="md:hidden space-y-3">
//             {filteredPackages.map((pkg) => (
//               <div key={pkg.reference_id} className="bg-white rounded-lg shadow p-4">
//                 <div className="flex justify-between items-start mb-2">
//                   <span className="text-xs text-gray-500 font-mono">{pkg.reference_id}</span>
//                   <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
//                     pkg.status === 'pending' ? 'bg-amber-100 text-amber-800' :
//                     pkg.status === 'fully_approved' ? 'bg-green-100 text-green-800' :
//                     pkg.status.startsWith('approved_by_') ? 'bg-blue-100 text-blue-800' :
//                     pkg.status.startsWith('rejected_by_') ? 'bg-red-100 text-red-800' :
//                     'bg-gray-100 text-gray-800'
//                   }`}>
//                     {pkg.status === 'pending' ? 'Pending' :
//                      pkg.status === 'fully_approved' ? 'Fully Approved' :
//                      pkg.status.startsWith('approved_by_') ? `Approved by ${pkg.status.replace('approved_by_', '').replace('_', ' ')}` :
//                      pkg.status.startsWith('rejected_by_') ? `Rejected by ${pkg.status.replace('rejected_by_', '').replace('_', ' ')}` :
//                      pkg.status}
//                   </span>
//                 </div>
//                 <p className="font-semibold text-gray-900 text-sm mb-1">
//                   {pkg.data?.['Package Name'] || 'N/A'}
//                   {pkg.linked_previous && pkg.linked_previous.length > 0 && (
//                     <span className="ml-2 bg-amber-100 text-amber-800 text-xs px-2 py-0.5 rounded-full">Revised</span>
//                   )}
//                 </p>
//                 <p className="text-xs text-gray-500 mb-3">{formatDate(pkg.created_at)}</p>
//                 {pkg.approver_role && canAct(pkg) && (
//                   <p className="text-xs text-indigo-600 mb-2">⏳ Awaiting: {pkg.approver_role.replace(/_/g, ' ')}</p>
//                 )}
//                 <div className="flex flex-wrap gap-2">
//                   <button className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleView(pkg)}>View</button>
//                   {canAct(pkg) && (
//                     <>
//                       <button className="bg-green-500 hover:bg-green-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleApprove(pkg.reference_id)}>Approve</button>
//                       <button className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleReject(pkg.reference_id)}>Reject</button>
//                     </>
//                   )}
//                   {role === 'super_admin' && (
//                     <button className="bg-red-700 hover:bg-red-800 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleDelete(pkg.reference_id)}>Delete</button>
//                   )}
//                   {role === 'employee' && pkg.user_id === userId && pkg.status === 'pending' && (
//                     <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleEdit(pkg)}>Edit</button>
//                   )}
//                   <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleDownloadPDF(pkg)}>PDF</button>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Desktop Table */}
//           <div className="hidden md:block overflow-x-auto bg-white shadow-lg rounded-lg">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-indigo-600">
//                 <tr>
//                   <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Reference ID</th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Package Name</th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Created</th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Status</th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {filteredPackages.map((pkg) => (
//                   <tr key={pkg.reference_id} className="hover:bg-gray-50 transition-colors">
//                     <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{pkg.reference_id}</td>
//                     <td className="px-4 sm:px-6 py-4 text-sm text-gray-900">
//                       <div className="flex items-center gap-2 flex-wrap">
//                         <span>{pkg.data?.['Package Name'] || 'N/A'}</span>
//                         {pkg.linked_previous && pkg.linked_previous.length > 0 && (
//                           <span className="bg-amber-100 text-amber-800 text-xs font-medium px-2.5 py-1 rounded-full">Revised ({pkg.linked_previous.length})</span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(pkg.created_at)}</td>
//                     <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm">
//                       <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                         pkg.status === 'pending' ? 'bg-amber-100 text-amber-800' :
//                         pkg.status === 'fully_approved' ? 'bg-green-100 text-green-800' :
//                         pkg.status.startsWith('approved_by_') ? 'bg-blue-100 text-blue-800' :
//                         pkg.status.startsWith('rejected_by_') ? 'bg-red-100 text-red-800' :
//                         'bg-gray-100 text-gray-800'
//                       }`}>
//                         {pkg.status === 'pending' ? 'Pending' :
//                          pkg.status === 'fully_approved' ? 'Fully Approved' :
//                          pkg.status.startsWith('approved_by_') ? `Approved by ${pkg.status.replace('approved_by_', '').replace('_', ' ')}` :
//                          pkg.status.startsWith('rejected_by_') ? `Rejected by ${pkg.status.replace('rejected_by_', '').replace('_', ' ')}` :
//                          pkg.status}
//                       </span>
//                       {pkg.approver_role && canAct(pkg) && (
//                         <div className="text-xs text-indigo-600 mt-1 font-medium">⏳ Awaiting: {pkg.approver_role.replace(/_/g, ' ')}</div>
//                       )}
//                     </td>
//                     <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm">
//                       <div className="flex flex-wrap gap-2">
//                         <button className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleView(pkg)}>View</button>
//                         {canAct(pkg) && (
//                           <>
//                             <button className="bg-green-500 hover:bg-green-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleApprove(pkg.reference_id)}>Approve</button>
//                             <button className="bg-red-500 hover:bg-red-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleReject(pkg.reference_id)}>Reject</button>
//                           </>
//                         )}
//                         {role === 'super_admin' && (
//                           <button className="bg-red-700 hover:bg-red-800 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleDelete(pkg.reference_id)}>Delete</button>
//                         )}
//                         {role === 'employee' && pkg.user_id === userId && pkg.status === 'pending' && (
//                           <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleEdit(pkg)}>Edit</button>
//                         )}
//                         <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleDownloadPDF(pkg)}>PDF</button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </>
//       ) : (
//         <div className="bg-white p-8 rounded-xl shadow text-center">
//           <p className="text-gray-600 text-lg mb-4">No packages found.</p>
//           {filterStatus && (
//             <button
//               onClick={() => navigate('/dashboard/view-packages')}
//               className="text-indigo-600 hover:text-indigo-800 font-medium"
//             >
//               Clear filter and view all packages
//             </button>
//           )}
//         </div>
//       )}

//       {selectedPackage && (
//         <div className="fixed inset-0 bg-black bg-opacity-60 z-50 overflow-y-auto p-2 sm:p-4">
//           <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl mx-auto mt-2 sm:mt-6 mb-4 sm:mb-6">
//             <div className="bg-indigo-700 text-white p-4 sm:p-6 text-center rounded-t-xl sticky top-0 z-50">
//               <h3 className="text-xl sm:text-3xl font-bold">Package Costing</h3>
//               <p className="mt-1 sm:mt-2 text-base sm:text-xl">Reference ID: {selectedPackage.reference_id}</p>
//               <p className="text-sm sm:text-lg">Created: {formatDate(selectedPackage.created_at)}</p>
//               <div className="mt-2">
//                 <span className={`px-3 py-1 rounded-full text-sm font-medium ${
//                   selectedPackage.status === 'pending' ? 'bg-amber-500' :
//                   selectedPackage.status === 'fully_approved' ? 'bg-green-500' :
//                   selectedPackage.status.startsWith('approved_by_') ? 'bg-blue-500' :
//                   'bg-red-500'
//                 }`}>
//                   {selectedPackage.status.replace(/_/g, ' ').toUpperCase()}
//                 </span>
//               </div>
//             </div>

//             <div className="p-3 sm:p-6 space-y-4 sm:space-y-6 overflow-y-auto max-h-[75vh]">
//               {linkedPrevious.length > 0 && (
//                 <div className="bg-amber-50 border border-amber-300 rounded-xl p-6">
//                   <h5 className="text-2xl font-bold text-amber-800 mb-4">Previous Versions of This Package</h5>
//                   <p className="text-amber-700 mb-4">This is a revised submission. View earlier versions below:</p>
//                   <div className="space-y-3">
//                     {linkedPrevious.map((prev) => (
//                       <div key={prev.reference_id} className="bg-white border border-amber-200 rounded-lg p-4 flex justify-between items-center shadow-sm">
//                         <div>
//                           <strong className="text-lg text-indigo-700">{prev.reference_id}</strong>
//                           <span className="text-gray-600 ml-3">({formatDate(prev.created_at)})</span>
//                           <br />
//                           <small className="text-gray-500">{prev.package_name || 'Unnamed Package'}</small>
//                         </div>
//                         <div className="flex gap-3">
//                           <a href={`/public-view/${prev.reference_id}`} target="_blank" rel="noopener noreferrer" className="bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-lg text-sm">View</a>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               <div>
//                 <h5 className="text-2xl font-bold text-indigo-700 mb-4">Costing by</h5>
//                 <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
//                   <tbody>
//                     {['Employee', 'Agent', 'Agency', 'Agent Email', 'Number'].map((field) => (
//                       <tr key={field} className="border-b last:border-b-0 bg-gray-50">
//                         <td className="p-4 font-medium w-1/3">{field}</td>
//                         <td className="p-4">{selectedPackage.data?.[`${field === 'Agent Email' ? 'Agent Email' : field === 'Number' ? 'Agent Number' : field + ' Name'}`] || 'N/A'}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div>
//                 <h5 className="text-2xl font-bold text-indigo-700 mb-4">Costing to</h5>
//                 <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
//                   <tbody>
//                     {['Customer', 'Email', 'Mobile'].map((field) => (
//                       <tr key={field} className="border-b last:border-b-0 bg-gray-50">
//                         <td className="p-4 font-medium w-1/3">{field}</td>
//                         <td className="p-4">{selectedPackage.data?.[`Customer ${field}`] || 'N/A'}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div>
//                 <h5 className="text-2xl font-bold text-indigo-700 mb-4">Package Details</h5>
//                 <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
//                   <tbody>
//                     {[
//                       ['Package Name', selectedPackage.data?.['Package Name']],
//                       ['Start Date', formatDate(selectedPackage.data?.['Start Date'])],
//                       ['End Date', formatDate(selectedPackage.data?.['End Date'])],
//                       ['Duration', `${selectedPackage.data?.['Days'] || 'N/A'} Days, ${selectedPackage.data?.['Nights'] || 'N/A'} Nights`],
//                       ['No. of Pax', selectedPackage.data?.['No. of Pax']],
//                       ['Travelling Members', (selectedPackage.data?.['Travelling Members'] || []).join(', ') || 'N/A'],
//                       ['Currency', `${selectedPackage.currency} (${symbols[selectedPackage.currency]})`],
//                       selectedPackage.converted_currency ? ['Converted Currency', `${selectedPackage.converted_currency} (${symbols[selectedPackage.converted_currency]})`] : null
//                     ].filter(Boolean).map(([label, value], i) => (
//                       <tr key={i} className="border-b last:border-b-0 bg-gray-50">
//                         <td className="p-4 font-medium w-1/3">{label}</td>
//                         <td className="p-4">{value || 'N/A'}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div>
//                 <h5 className="text-2xl font-bold text-indigo-700 mb-4">Item Details</h5>
//                 <div className="overflow-x-auto border rounded-lg">
//                   <table className="w-full">
//                     <thead className="bg-teal-600 text-white">
//                       <tr>
//                         <th className="p-4 text-left">Sr no</th>
//                         <th className="p-4 text-left">Item Description</th>
//                         <th className="p-4 text-center">Qty.</th>
//                         <th className="p-4 text-right">Rate</th>
//                         <th className="p-4 text-right">Amount</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {[
//                         ...costingFields.map(field => ({ desc: field, amount: parseFloat(selectedPackage.data?.[field] || 0) })),
//                         ...(selectedPackage.data?.['Extra Costs'] || []).filter(c => c?.value).map(ec => ({ desc: ec.label || 'Extra', amount: parseFloat(ec.value || 0) }))
//                       ].filter(item => item.amount > 0).map((item, index) => (
//                         <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : ''}>
//                           <td className="p-4">{index + 1}</td>
//                           <td className="p-4">{item.desc}</td>
//                           <td className="p-4 text-center">1</td>
//                           <td className="p-4 text-right">{symbols[selectedPackage.currency]}{item.amount.toFixed(2)}</td>
//                           <td className="p-4 text-right font-bold">{symbols[selectedPackage.currency]}{item.amount.toFixed(2)}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <div>
//                 <h5 className="text-2xl font-bold text-indigo-700 mb-4">Financial Details</h5>
//                 <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
//                   <thead className="bg-teal-600 text-white">
//                     <tr>
//                       <th className="p-4 text-left">Financial Detail</th>
//                       <th className="p-4 text-right">Amount (%)</th>
//                       {selectedPackage.converted_currency && <th className="p-4 text-right">Converted Amount</th>}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {['Net Cost', 'Mark-up', 'Selling Price to Customer', 'Per Pax Selling Price', 'Less: Agent Commission', 'Less: Transaction Charges', 'Gross Margin'].map((field, i) => (
//                       <tr key={field} className={i % 2 === 0 ? 'bg-gray-50' : ''}>
//                         <td className="p-4 font-medium">{field}</td>
//                         <td className="p-4 text-right">
//                           {symbols[selectedPackage.currency]}{parseFloat(selectedPackage.data?.[field] || 0).toFixed(2)}
//                           {['Mark-up', 'Less: Agent Commission', 'Less: Transaction Charges', 'Gross Margin'].includes(field) && 
//                             <span className="text-sm text-gray-600 ml-2">({selectedPackage.data?.[`${field} %`] || '0'}%)</span>
//                           }
//                         </td>
//                         {selectedPackage.converted_currency && (
//                           <td className="p-4 text-right">
//                             {convertedFields.includes(field) && selectedPackage.data?.[`Converted ${field}`] > 0 
//                               ? `${symbols[selectedPackage.converted_currency]}${Number(selectedPackage.data[`Converted ${field}`]).toLocaleString()}`
//                               : '—'}
//                           </td>
//                         )}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div>
//                 <h5 className="text-2xl font-bold text-indigo-700 mb-4">Totals</h5>
//                 <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-8 rounded-2xl text-center">
//                   <p className="text-5xl font-bold">
//                     {symbols[selectedPackage.currency]}{parseFloat(selectedPackage.data?.['Selling Price to Customer'] || 0).toFixed(2)}
//                   </p>
//                   <p className="mt-6 text-2xl">
//                     {numberToWords(parseFloat(selectedPackage.data?.['Selling Price to Customer'] || 0))} {selectedPackage.currency === 'INR' ? 'Rupees' : 'Dollars'} Only
//                   </p>
//                 </div>
//               </div>

//               <div>
//                 <h5 className="text-2xl font-bold text-indigo-700 mb-4">Approval History</h5>
//                 <div className="overflow-x-auto border rounded-lg">
//                   <table className="w-full">
//                     <thead className="bg-teal-600 text-white">
//                       <tr>
//                         <th className="p-4 text-left">#</th>
//                         <th className="p-4 text-left">Action</th>
//                         <th className="p-4 text-left">Role</th>
//                         <th className="p-4 text-left">Name / Email</th>
//                         <th className="p-4 text-left">Date & Time</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {approvalHistory.length > 0 ? approvalHistory.map((item, i) => {
//                         const isCreated  = item.type === 'created';
//                         const isApproved = item.action === 'APPROVED';
//                         const actionBadge = isCreated
//                           ? <span className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full text-xs font-semibold">📝 Created</span>
//                           : isApproved
//                           ? <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-semibold">✅ Approved</span>
//                           : <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-semibold">❌ Rejected</span>;

//                         const roleLabel = item.role
//                           ? item.role.replace(/_/g, ' ').replace(/\w/g, c => c.toUpperCase())
//                           : 'N/A';

//                         return (
//                           <tr key={i} className={i % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
//                             <td className="p-4 text-gray-500 text-sm">{i + 1}</td>
//                             <td className="p-4">{actionBadge}</td>
//                             <td className="p-4 text-sm font-medium text-gray-700">{roleLabel}</td>
//                             <td className="p-4">
//                               <p className="font-semibold text-gray-900">{item.user_name}</p>
//                               <p className="text-sm text-gray-500">{item.user_email}</p>
//                             </td>
//                             <td className="p-4 text-sm text-gray-600">{formatDateTime(item.created_at)}</td>
//                           </tr>
//                         );
//                       }) : (
//                         <tr>
//                           <td colSpan="5" className="p-8 text-center text-gray-500">No approval history available</td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-gray-100 p-4 sm:p-6 border-t flex justify-center gap-3 sm:gap-6 flex-wrap">
//               {canAct(selectedPackage) && (
//                 <>
//                   <button className="bg-green-600 hover:bg-green-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={() => handleApprove(selectedPackage.reference_id)}>Approve</button>
//                   <button className="bg-red-600 hover:bg-red-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={() => handleReject(selectedPackage.reference_id)}>Reject</button>
//                 </>
//               )}
//               <button className="bg-blue-600 hover:bg-blue-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={() => handleDownloadPDF(selectedPackage)}>Download PDF</button>
//               <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={closeModal}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ViewPackages;
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  getPackages, 
  approvePackage, 
  rejectPackage, 
  deletePackage,
  getPackageHistory
} from '../services/api';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../assets/ZAUNTRIP-Logo1.png';

// ─────────────────────────────────────────────────────────────────────────────
// Helper: write all auth fields from the email deep-link into localStorage
// so the rest of the app behaves exactly as if the user had logged in normally.
// ─────────────────────────────────────────────────────────────────────────────
function applySessionFromParams(params) {
  const sessionToken = params.get('sessionToken');
  const refId        = params.get('refId');
  if (!sessionToken) return null;

  // Persist the session exactly as the /auth endpoint would
  localStorage.setItem('token',         sessionToken);
  localStorage.setItem('user_id',       params.get('user_id')       || '');
  localStorage.setItem('role',          params.get('role')           || '');
  localStorage.setItem('username',      params.get('username')       || '');
  localStorage.setItem('email',         params.get('email')          || '');
  localStorage.setItem('employee_name', params.get('employee_name')  || '');
  localStorage.setItem('employee_code', params.get('employee_code')  || '');

  return refId; // caller uses this to auto-open the modal
}

const ViewPackages = () => {
  const [packages,         setPackages]         = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [selectedPackage,  setSelectedPackage]  = useState(null);
  const [approvalHistory,  setApprovalHistory]  = useState([]);
  const [linkedPrevious,   setLinkedPrevious]   = useState([]);
  const [rates,            setRates]            = useState({});
  const [loading,          setLoading]          = useState(true);
  // Track which refId should be auto-opened (set by email deep-link)
  const [autoOpenRefId,    setAutoOpenRefId]    = useState(null);

  const role   = localStorage.getItem('role')    || 'employee';
  const userId = parseInt(localStorage.getItem('user_id') || '0', 10);

  const navigate = useNavigate();
  const location = useLocation();

  const filterStatus = location.state?.filterStatus;

  const approvalOrder = ['manager', 'functional_admin', 'super_admin'];
  const symbols       = { USD: '$', INR: '₹' };
  const costingFields = [
    'Flights / Airfare', 'Accommodation', 'Transfers', 'Sightseeing', 'Meals',
    'Visa Fees', 'Travel Insurance', 'Guide / Driver Tips',
  ];
  const convertedFields = [
    'Mark-up', 'Per Pax Selling Price', 'Less: Agent Commission',
    'Less: Transaction Charges', 'Gross Margin'
  ];

  // ── Step 1: On first mount, check for email deep-link query params ─────────
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('sessionToken')) {
      const refId = applySessionFromParams(params);

      // Clean the URL so the tokens don't sit in the address bar
      window.history.replaceState({}, '', window.location.pathname);

      if (refId) {
        // We'll open the modal once the package list has loaded (see Step 3)
        setAutoOpenRefId(refId);
      }
    }
  }, []);

  const fetchRates = async () => {
    try {
      const res  = await fetch('https://open.er-api.com/v6/latest/USD');
      const data = await res.json();
      if (data.result === 'success') setRates(data.rates);
    } catch (err) {
      console.error('Failed to fetch exchange rates:', err);
    }
  };

  const fetchPackages = useCallback(async () => {
    // Don't show the spinner on background polls (only on first load)
    if (packages.length === 0) setLoading(true);
    try {
      const response = await getPackages();
      const data     = Array.isArray(response.data) ? response.data : [];

      const parsedPackages = data.map(pkg => {
        let parsedData = {};
        try {
          parsedData = typeof pkg.data === 'string' ? JSON.parse(pkg.data) : pkg.data || {};
        } catch (e) {
          parsedData = {};
        }
        return {
          ...pkg,
          currency:             pkg.currency             || 'INR',
          converted_currency:   pkg.converted_currency   || null,
          data:                 parsedData,
          approver_role:        pkg.approver_role        || null,
          assigned_approver_id: parseInt(pkg.assigned_approver_id) || null,
          user_id:              parseInt(pkg.user_id)    || 0
        };
      });

      setPackages(parsedPackages);

      let filtered = parsedPackages;

      if (role === 'super_admin') {
        filtered = parsedPackages;
      } else if (role === 'employee') {
        filtered = parsedPackages.filter(pkg => pkg.user_id === userId);
      } else if (role === 'manager') {
        filtered = parsedPackages.filter(pkg => {
          if (pkg.user_id === userId) return true;
          const isPendingForManager = pkg.status === 'pending' && pkg.approver_role === 'manager';
          const isMyAssignment      = !pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === userId;
          if (isPendingForManager && isMyAssignment) return true;
          if (pkg.status === 'approved_by_manager'         || pkg.status === 'rejected_by_manager')         return true;
          if (pkg.status === 'approved_by_functional_admin'|| pkg.status === 'fully_approved')              return true;
          return false;
        });
      } else if (role === 'functional_admin') {
        filtered = parsedPackages.filter(pkg => {
          if (pkg.status === 'pending'                           && pkg.approver_role === 'functional_admin') return true;
          if (pkg.status === 'approved_by_manager')                                                          return true;
          if (pkg.status === 'approved_by_functional_admin')                                                 return true;
          if (pkg.status === 'fully_approved')                                                               return true;
          if (pkg.status.startsWith('rejected_by_functional_admin'))                                        return true;
          if (pkg.status.startsWith('rejected_by_manager'))                                                 return true;
          return false;
        });
      }

      // Apply status filter if provided via navigation state
      if (filterStatus && filterStatus !== 'all') {
        if (filterStatus === 'pending') {
          const actionableForRole = {
            manager:          ['pending'],
            functional_admin: ['pending', 'approved_by_manager'],
            super_admin:      ['pending', 'approved_by_manager', 'approved_by_functional_admin']
          };
          const pendingStatuses = actionableForRole[role] || ['pending'];
          filtered = filtered.filter(pkg => pendingStatuses.includes(pkg.status));
        } else if (filterStatus === 'approved') {
          filtered = filtered.filter(pkg =>
            pkg.status === 'fully_approved' || pkg.status.startsWith('approved_by_')
          );
        } else if (filterStatus === 'rejected') {
          filtered = filtered.filter(pkg => pkg.status.startsWith('rejected_by_'));
        }
      }

      setFilteredPackages(filtered);
      return parsedPackages; // returned so Step 3 can use it
    } catch (error) {
      console.error('Failed to fetch packages:', error.message);
      setPackages([]);
      setFilteredPackages([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, [role, userId, filterStatus]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Step 2: Load packages + start real-time polling ───────────────────────
  useEffect(() => {
    fetchPackages();
    fetchRates();

    const interval = setInterval(() => {
      fetchPackages();
    }, 5000); // poll every 5 s for real-time updates

    return () => clearInterval(interval);
  }, [fetchPackages]);

  // ── Step 3: Auto-open the package from the email deep-link ────────────────
  // Runs whenever `autoOpenRefId` or `packages` changes.
  // Once we find the target package in the loaded list we open it once and
  // clear the trigger so it doesn't re-fire on subsequent polls.
  useEffect(() => {
    if (!autoOpenRefId || packages.length === 0) return;

    const target = packages.find(p => p.reference_id === autoOpenRefId);
    if (target) {
      handleView(target);          // open modal
      setAutoOpenRefId(null);      // clear trigger
    }
  }, [autoOpenRefId, packages]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Also keep the open modal in sync with real-time status updates ────────
  // When `packages` refreshes (background poll), if a modal is open, update
  // the selectedPackage so the status badge reflects the latest DB value.
  useEffect(() => {
    if (!selectedPackage || packages.length === 0) return;
    const fresh = packages.find(p => p.reference_id === selectedPackage.reference_id);
    if (fresh && fresh.status !== selectedPackage.status) {
      setSelectedPackage(prev => ({ ...prev, status: fresh.status, approver_role: fresh.approver_role }));
    }
  }, [packages]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatDate = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) return 'N/A';
    return new Date(dateString).toLocaleString('en-GB', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true
    });
  };

  const canAct = (pkg) => {
    if (!pkg.approver_role) return false;

    const actionableStatuses = {
      manager:          ['pending'],
      functional_admin: ['pending', 'approved_by_manager'],
      super_admin:      ['pending', 'approved_by_manager', 'approved_by_functional_admin']
    };
    const allowed = actionableStatuses[role] || ['pending'];
    if (!allowed.includes(pkg.status)) return false;

    if (pkg.approver_role !== role) return false;

    if (pkg.assigned_approver_id) {
      return Number(pkg.assigned_approver_id) === Number(userId);
    }

    return true;
  };

  const handleApprove = async (referenceId) => {
    const pkgRole = selectedPackage?.approver_role || role;
    try {
      await approvePackage(referenceId, pkgRole);
      alert('Package approved successfully!');
      closeModal();
      await fetchPackages();     // immediate refresh so list + stats update
    } catch (error) {
      console.error('Approve error:', error);
      alert('Failed to approve package. Please try again. Error: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleReject = async (referenceId) => {
    if (window.confirm('Are you sure you want to reject this package?')) {
      const pkgRole = selectedPackage?.approver_role || role;
      try {
        await rejectPackage(referenceId, pkgRole);
        alert('Package rejected successfully!');
        closeModal();
        await fetchPackages();   // immediate refresh
      } catch (error) {
        console.error('Reject error:', error);
        alert('Failed to reject package. Please try again. Error: ' + (error.response?.data?.error || error.message));
      }
    }
  };

  const handleDelete = async (referenceId) => {
    if (window.confirm('Are you sure you want to delete this package?')) {
      try {
        await deletePackage(referenceId);
        alert('Package deleted successfully!');
        await fetchPackages();
        if (selectedPackage?.reference_id === referenceId) setSelectedPackage(null);
      } catch (error) {
        console.error('Delete error:', error);
        alert('Failed to delete package. Please try again.');
      }
    }
  };

  const handleView = async (pkg) => {
    let safePkg = { ...pkg };
    try {
      safePkg.data = typeof pkg.data === 'string' ? JSON.parse(pkg.data) : pkg.data || {};
    } catch (e) {
      safePkg.data = {};
    }

    setSelectedPackage(safePkg);
    setLinkedPrevious(pkg.linked_previous || []);

    try {
      const res     = await getPackageHistory(pkg.reference_id);
      const history = Array.isArray(res.data?.history) ? res.data.history : [];

      const formattedHistory = history.map(h => ({
        type:       h.type || 'approval',
        action:     h.action || (h.approved ? 'APPROVED' : 'REJECTED'),
        role:       h.role || 'employee',
        user_name:  h.approver_name  || 'N/A',
        user_email: h.approver_email || 'N/A',
        created_at: h.approved_at
      }));

      setApprovalHistory(formattedHistory);
    } catch (err) {
      console.error('Failed to fetch approval history:', err);
      setApprovalHistory([{
        type:       'created',
        action:     'CREATED',
        role:       'employee',
        user_name:  safePkg.data['Employee Name'] || 'N/A',
        user_email: safePkg.data['Agent Email']   || 'N/A',
        created_at: pkg.created_at
      }]);
    }
  };

  const handleEdit = (pkg) => {
    if (role === 'employee' && pkg.user_id === userId && pkg.status === 'pending') {
      navigate(`/dashboard/edit-package/${pkg.reference_id}`, { state: { package: pkg } });
    } else {
      alert('You can only edit your own pending packages.');
    }
  };

  const closeModal = () => {
    setSelectedPackage(null);
    setApprovalHistory([]);
    setLinkedPrevious([]);
  };

  const numberToWords = (num) => {
    if (isNaN(num) || num === 0) return 'Zero';
    const units  = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens  = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens   = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const scales = ['', 'Thousand', 'Million', 'Billion'];

    const convertChunk = (n) => {
      if (n === 0)   return '';
      if (n < 10)    return units[n];
      if (n < 20)    return teens[n - 10];
      if (n < 100)   return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + units[n % 10] : '');
      return units[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + convertChunk(n % 100) : '');
    };

    const chunks    = [];
    let remaining   = Math.floor(Math.abs(num));
    for (let i = 0; remaining > 0 && i < scales.length; i++) {
      const chunk = remaining % 1000;
      if (chunk > 0) chunks.unshift(convertChunk(chunk) + (chunk > 99 ? ' ' : '') + scales[i]);
      remaining = Math.floor(remaining / 1000);
    }
    return chunks.join(' ').trim() + (num < 0 ? ' Negative' : '') + ' Only';
  };

  const getLogoBase64 = async () => {
    return new Promise((resolve) => {
      const img   = new Image();
      img.src     = logo;
      img.onload  = () => {
        const canvas = document.createElement('canvas');
        canvas.width  = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => resolve(null);
    });
  };

  const handleDownloadPDF = async (pkg) => {
    if (!pkg || !pkg.reference_id) return alert('Invalid package');

    let data = {};
    try {
      data = typeof pkg.data === 'string' ? JSON.parse(pkg.data) : pkg.data || {};
    } catch (e) {
      return alert('Package data corrupted');
    }

    const doc       = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 20;

    const logoBase64 = await getLogoBase64();
    if (logoBase64) doc.addImage(logoBase64, 'PNG', 10, 6, 30, 10);

    doc.setFontSize(16);
    doc.text('Package Costing', pageWidth / 2, 15, { align: 'center' });

    doc.setFontSize(10);
    doc.text(`Reference ID: ${pkg.reference_id}`, 10, y); y += 8;
    doc.text(`Created: ${formatDate(pkg.created_at)}`, 10, y);   y += 8;
    doc.text(`Status: ${pkg.status.replace(/_/g, ' ').toUpperCase()}`, 10, y); y += 12;

    const rows = Object.entries(data).map(([k, v]) => [k, v || '-']);
    autoTable(doc, { startY: y, head: [['Cost Head', 'Amount']], body: rows, theme: 'grid', styles: { fontSize: 9 } });

    let nextY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.text('Approval History', 10, nextY); nextY += 8;

    if (approvalHistory.length > 0) {
      autoTable(doc, {
        startY: nextY,
        head: [['Action', 'Role', 'User', 'Date & Time']],
        body: approvalHistory.map(h => [
          h.action,
          h.role,
          `${h.user_name} (${h.user_email})`,
          formatDateTime(h.created_at)
        ]),
        styles: { fontSize: 9 }
      });
    }

    doc.save(`Package_Costing_${pkg.reference_id}.pdf`);
  };

  return (
    <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
      <div className="flex flex-wrap justify-between items-center mb-4 sm:mb-6 gap-2">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">View Packages</h2>
        {filterStatus && (
          <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm font-medium">
            Filter: {filterStatus}
          </span>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
          <span className="ml-4 text-gray-600">Loading packages...</span>
        </div>
      ) : filteredPackages.length > 0 ? (
        <>
          {/* Mobile Cards */}
          <div className="md:hidden space-y-3">
            {filteredPackages.map((pkg) => (
              <div key={pkg.reference_id} className="bg-white rounded-lg shadow p-4">
                <div className="flex justify-between items-start mb-2">
                  <span className="text-xs text-gray-500 font-mono">{pkg.reference_id}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                    pkg.status === 'pending'                      ? 'bg-amber-100 text-amber-800' :
                    pkg.status === 'fully_approved'              ? 'bg-green-100 text-green-800' :
                    pkg.status.startsWith('approved_by_')        ? 'bg-blue-100 text-blue-800'  :
                    pkg.status.startsWith('rejected_by_')        ? 'bg-red-100 text-red-800'    :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {pkg.status === 'pending'             ? 'Pending' :
                     pkg.status === 'fully_approved'      ? 'Fully Approved' :
                     pkg.status.startsWith('approved_by_')? `Approved by ${pkg.status.replace('approved_by_', '').replace('_', ' ')}` :
                     pkg.status.startsWith('rejected_by_')? `Rejected by ${pkg.status.replace('rejected_by_', '').replace('_', ' ')}` :
                     pkg.status}
                  </span>
                </div>
                <p className="font-semibold text-gray-900 text-sm mb-1">
                  {pkg.data?.['Package Name'] || 'N/A'}
                  {pkg.linked_previous && pkg.linked_previous.length > 0 && (
                    <span className="ml-2 bg-amber-100 text-amber-800 text-xs px-2 py-0.5 rounded-full">Revised</span>
                  )}
                </p>
                <p className="text-xs text-gray-500 mb-3">{formatDate(pkg.created_at)}</p>
                {pkg.approver_role && canAct(pkg) && (
                  <p className="text-xs text-indigo-600 mb-2">⏳ Awaiting: {pkg.approver_role.replace(/_/g, ' ')}</p>
                )}
                <div className="flex flex-wrap gap-2">
                  <button className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleView(pkg)}>View</button>
                  {canAct(pkg) && (
                    <>
                      <button className="bg-green-500 hover:bg-green-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleApprove(pkg.reference_id)}>Approve</button>
                      <button className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleReject(pkg.reference_id)}>Reject</button>
                    </>
                  )}
                  {role === 'super_admin' && (
                    <button className="bg-red-700 hover:bg-red-800 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleDelete(pkg.reference_id)}>Delete</button>
                  )}
                  {role === 'employee' && pkg.user_id === userId && pkg.status === 'pending' && (
                    <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleEdit(pkg)}>Edit</button>
                  )}
                  <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded text-xs" onClick={() => handleDownloadPDF(pkg)}>PDF</button>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto bg-white shadow-lg rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-indigo-600">
                <tr>
                  <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Reference ID</th>
                  <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Package Name</th>
                  <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Created</th>
                  <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Status</th>
                  <th className="px-4 sm:px-6 py-3 text-left text-sm font-semibold text-white">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredPackages.map((pkg) => (
                  <tr key={pkg.reference_id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{pkg.reference_id}</td>
                    <td className="px-4 sm:px-6 py-4 text-sm text-gray-900">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span>{pkg.data?.['Package Name'] || 'N/A'}</span>
                        {pkg.linked_previous && pkg.linked_previous.length > 0 && (
                          <span className="bg-amber-100 text-amber-800 text-xs font-medium px-2.5 py-1 rounded-full">Revised ({pkg.linked_previous.length})</span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(pkg.created_at)}</td>
                    <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        pkg.status === 'pending'                     ? 'bg-amber-100 text-amber-800' :
                        pkg.status === 'fully_approved'             ? 'bg-green-100 text-green-800' :
                        pkg.status.startsWith('approved_by_')       ? 'bg-blue-100 text-blue-800'  :
                        pkg.status.startsWith('rejected_by_')       ? 'bg-red-100 text-red-800'    :
                        'bg-gray-100 text-gray-800'
                      }`}>
                        {pkg.status === 'pending'             ? 'Pending' :
                         pkg.status === 'fully_approved'      ? 'Fully Approved' :
                         pkg.status.startsWith('approved_by_')? `Approved by ${pkg.status.replace('approved_by_', '').replace('_', ' ')}` :
                         pkg.status.startsWith('rejected_by_')? `Rejected by ${pkg.status.replace('rejected_by_', '').replace('_', ' ')}` :
                         pkg.status}
                      </span>
                      {pkg.approver_role && canAct(pkg) && (
                        <div className="text-xs text-indigo-600 mt-1 font-medium">⏳ Awaiting: {pkg.approver_role.replace(/_/g, ' ')}</div>
                      )}
                    </td>
                    <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm">
                      <div className="flex flex-wrap gap-2">
                        <button className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleView(pkg)}>View</button>
                        {canAct(pkg) && (
                          <>
                            <button className="bg-green-500 hover:bg-green-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleApprove(pkg.reference_id)}>Approve</button>
                            <button className="bg-red-500 hover:bg-red-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleReject(pkg.reference_id)}>Reject</button>
                          </>
                        )}
                        {role === 'super_admin' && (
                          <button className="bg-red-700 hover:bg-red-800 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleDelete(pkg.reference_id)}>Delete</button>
                        )}
                        {role === 'employee' && pkg.user_id === userId && pkg.status === 'pending' && (
                          <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleEdit(pkg)}>Edit</button>
                        )}
                        <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm" onClick={() => handleDownloadPDF(pkg)}>PDF</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="bg-white p-8 rounded-xl shadow text-center">
          <p className="text-gray-600 text-lg mb-4">No packages found.</p>
          {filterStatus && (
            <button
              onClick={() => navigate('/dashboard/view-packages')}
              className="text-indigo-600 hover:text-indigo-800 font-medium"
            >
              Clear filter and view all packages
            </button>
          )}
        </div>
      )}

      {selectedPackage && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 overflow-y-auto p-2 sm:p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl mx-auto mt-2 sm:mt-6 mb-4 sm:mb-6">
            <div className="bg-indigo-700 text-white p-4 sm:p-6 text-center rounded-t-xl sticky top-0 z-50">
              <h3 className="text-xl sm:text-3xl font-bold">Package Costing</h3>
              <p className="mt-1 sm:mt-2 text-base sm:text-xl">Reference ID: {selectedPackage.reference_id}</p>
              <p className="text-sm sm:text-lg">Created: {formatDate(selectedPackage.created_at)}</p>
              <div className="mt-2">
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                  selectedPackage.status === 'pending'                     ? 'bg-amber-500' :
                  selectedPackage.status === 'fully_approved'             ? 'bg-green-500' :
                  selectedPackage.status.startsWith('approved_by_')       ? 'bg-blue-500'  :
                  'bg-red-500'
                }`}>
                  {selectedPackage.status.replace(/_/g, ' ').toUpperCase()}
                </span>
              </div>
            </div>

            <div className="p-3 sm:p-6 space-y-4 sm:space-y-6 overflow-y-auto max-h-[75vh]">
              {linkedPrevious.length > 0 && (
                <div className="bg-amber-50 border border-amber-300 rounded-xl p-6">
                  <h5 className="text-2xl font-bold text-amber-800 mb-4">Previous Versions of This Package</h5>
                  <p className="text-amber-700 mb-4">This is a revised submission. View earlier versions below:</p>
                  <div className="space-y-3">
                    {linkedPrevious.map((prev) => (
                      <div key={prev.reference_id} className="bg-white border border-amber-200 rounded-lg p-4 flex justify-between items-center shadow-sm">
                        <div>
                          <strong className="text-lg text-indigo-700">{prev.reference_id}</strong>
                          <span className="text-gray-600 ml-3">({formatDate(prev.created_at)})</span>
                          <br />
                          <small className="text-gray-500">{prev.package_name || 'Unnamed Package'}</small>
                        </div>
                        <div className="flex gap-3">
                          <a href={`/public-view/${prev.reference_id}`} target="_blank" rel="noopener noreferrer" className="bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-lg text-sm">View</a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div>
                <h5 className="text-2xl font-bold text-indigo-700 mb-4">Costing by</h5>
                <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <tbody>
                    {['Employee', 'Agent', 'Agency', 'Agent Email', 'Number'].map((field) => (
                      <tr key={field} className="border-b last:border-b-0 bg-gray-50">
                        <td className="p-4 font-medium w-1/3">{field}</td>
                        <td className="p-4">{selectedPackage.data?.[`${field === 'Agent Email' ? 'Agent Email' : field === 'Number' ? 'Agent Number' : field + ' Name'}`] || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div>
                <h5 className="text-2xl font-bold text-indigo-700 mb-4">Costing to</h5>
                <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <tbody>
                    {['Customer', 'Email', 'Mobile'].map((field) => (
                      <tr key={field} className="border-b last:border-b-0 bg-gray-50">
                        <td className="p-4 font-medium w-1/3">{field}</td>
                        <td className="p-4">{selectedPackage.data?.[`Customer ${field}`] || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div>
                <h5 className="text-2xl font-bold text-indigo-700 mb-4">Package Details</h5>
                <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <tbody>
                    {[
                      ['Package Name', selectedPackage.data?.['Package Name']],
                      ['Start Date', formatDate(selectedPackage.data?.['Start Date'])],
                      ['End Date', formatDate(selectedPackage.data?.['End Date'])],
                      ['Duration', `${selectedPackage.data?.['Days'] || 'N/A'} Days, ${selectedPackage.data?.['Nights'] || 'N/A'} Nights`],
                      ['No. of Pax', selectedPackage.data?.['No. of Pax']],
                      ['Travelling Members', (selectedPackage.data?.['Travelling Members'] || []).join(', ') || 'N/A'],
                      ['Currency', `${selectedPackage.currency} (${symbols[selectedPackage.currency]})`],
                      selectedPackage.converted_currency ? ['Converted Currency', `${selectedPackage.converted_currency} (${symbols[selectedPackage.converted_currency]})`] : null
                    ].filter(Boolean).map(([label, value], i) => (
                      <tr key={i} className="border-b last:border-b-0 bg-gray-50">
                        <td className="p-4 font-medium w-1/3">{label}</td>
                        <td className="p-4">{value || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div>
                <h5 className="text-2xl font-bold text-indigo-700 mb-4">Item Details</h5>
                <div className="overflow-x-auto border rounded-lg">
                  <table className="w-full">
                    <thead className="bg-teal-600 text-white">
                      <tr>
                        <th className="p-4 text-left">Sr no</th>
                        <th className="p-4 text-left">Item Description</th>
                        <th className="p-4 text-center">Qty.</th>
                        <th className="p-4 text-right">Rate</th>
                        <th className="p-4 text-right">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ...costingFields.map(field => ({ desc: field, amount: parseFloat(selectedPackage.data?.[field] || 0) })),
                        ...(selectedPackage.data?.['Extra Costs'] || []).filter(c => c?.value).map(ec => ({ desc: ec.label || 'Extra', amount: parseFloat(ec.value || 0) }))
                      ].filter(item => item.amount > 0).map((item, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : ''}>
                          <td className="p-4">{index + 1}</td>
                          <td className="p-4">{item.desc}</td>
                          <td className="p-4 text-center">1</td>
                          <td className="p-4 text-right">{symbols[selectedPackage.currency]}{item.amount.toFixed(2)}</td>
                          <td className="p-4 text-right font-bold">{symbols[selectedPackage.currency]}{item.amount.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <h5 className="text-2xl font-bold text-indigo-700 mb-4">Financial Details</h5>
                <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <thead className="bg-teal-600 text-white">
                    <tr>
                      <th className="p-4 text-left">Financial Detail</th>
                      <th className="p-4 text-right">Amount (%)</th>
                      {selectedPackage.converted_currency && <th className="p-4 text-right">Converted Amount</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {['Net Cost', 'Mark-up', 'Selling Price to Customer', 'Per Pax Selling Price', 'Less: Agent Commission', 'Less: Transaction Charges', 'Gross Margin'].map((field, i) => (
                      <tr key={field} className={i % 2 === 0 ? 'bg-gray-50' : ''}>
                        <td className="p-4 font-medium">{field}</td>
                        <td className="p-4 text-right">
                          {symbols[selectedPackage.currency]}{parseFloat(selectedPackage.data?.[field] || 0).toFixed(2)}
                          {['Mark-up', 'Less: Agent Commission', 'Less: Transaction Charges', 'Gross Margin'].includes(field) && 
                            <span className="text-sm text-gray-600 ml-2">({selectedPackage.data?.[`${field} %`] || '0'}%)</span>
                          }
                        </td>
                        {selectedPackage.converted_currency && (
                          <td className="p-4 text-right">
                            {convertedFields.includes(field) && selectedPackage.data?.[`Converted ${field}`] > 0 
                              ? `${symbols[selectedPackage.converted_currency]}${Number(selectedPackage.data[`Converted ${field}`]).toLocaleString()}`
                              : '—'}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div>
                <h5 className="text-2xl font-bold text-indigo-700 mb-4">Totals</h5>
                <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-8 rounded-2xl text-center">
                  <p className="text-5xl font-bold">
                    {symbols[selectedPackage.currency]}{parseFloat(selectedPackage.data?.['Selling Price to Customer'] || 0).toFixed(2)}
                  </p>
                  <p className="mt-6 text-2xl">
                    {numberToWords(parseFloat(selectedPackage.data?.['Selling Price to Customer'] || 0))} {selectedPackage.currency === 'INR' ? 'Rupees' : 'Dollars'} Only
                  </p>
                </div>
              </div>

              <div>
                <h5 className="text-2xl font-bold text-indigo-700 mb-4">Approval History</h5>
                <div className="overflow-x-auto border rounded-lg">
                  <table className="w-full">
                    <thead className="bg-teal-600 text-white">
                      <tr>
                        <th className="p-4 text-left">#</th>
                        <th className="p-4 text-left">Action</th>
                        <th className="p-4 text-left">Role</th>
                        <th className="p-4 text-left">Name / Email</th>
                        <th className="p-4 text-left">Date & Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {approvalHistory.length > 0 ? approvalHistory.map((item, i) => {
                        const isCreated  = item.type === 'created';
                        const isApproved = item.action === 'APPROVED';
                        const actionBadge = isCreated
                          ? <span className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full text-xs font-semibold">📝 Created</span>
                          : isApproved
                          ? <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-semibold">✅ Approved</span>
                          : <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-semibold">❌ Rejected</span>;

                        const roleLabel = item.role
                          ? item.role.replace(/_/g, ' ').replace(/\w/g, c => c.toUpperCase())
                          : 'N/A';

                        return (
                          <tr key={i} className={i % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                            <td className="p-4 text-gray-500 text-sm">{i + 1}</td>
                            <td className="p-4">{actionBadge}</td>
                            <td className="p-4 text-sm font-medium text-gray-700">{roleLabel}</td>
                            <td className="p-4">
                              <p className="font-semibold text-gray-900">{item.user_name}</p>
                              <p className="text-sm text-gray-500">{item.user_email}</p>
                            </td>
                            <td className="p-4 text-sm text-gray-600">{formatDateTime(item.created_at)}</td>
                          </tr>
                        );
                      }) : (
                        <tr>
                          <td colSpan="5" className="p-8 text-center text-gray-500">No approval history available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 p-4 sm:p-6 border-t flex justify-center gap-3 sm:gap-6 flex-wrap">
              {canAct(selectedPackage) && (
                <>
                  <button className="bg-green-600 hover:bg-green-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={() => handleApprove(selectedPackage.reference_id)}>Approve</button>
                  <button className="bg-red-600 hover:bg-red-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={() => handleReject(selectedPackage.reference_id)}>Reject</button>
                </>
              )}
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={() => handleDownloadPDF(selectedPackage)}>Download PDF</button>
              <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 sm:px-8 py-2.5 sm:py-3 rounded-lg text-base sm:text-lg" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewPackages;